import React, { useState } from "react";
import { Link } from "react-router-dom";
import Modal from 'react-bootstrap/Modal';
import ChartsBody from "../../charts/ChartsBody";
import { Button } from "antd";
import PasswordChange from "./passwordChange/PasswordChange";
const AdminUsersTable = ({ data, handleDelete, initialVlue, handleChange, getUserData, reset }) => {
  const [show, setShow] = useState(false);
  function handleShow(breakpoint) {
    setShow(!show);
  }


  const [showPass, setShowPass] = useState(false);
  const [passid, setpassid] = useState(false);

  const passModalOpen = (id) => {
    setpassid(id)
    setShowPass(true)
  }
  return (
    <>
      <div className="pageTable">
        <div className="tableLength d-flex form-search">

          <div className="dataTables_length">
            <input
              type="text"
              className="form-control"
              name="search"
              id="language_level"
              autoComplete="off"
              placeholder="search..."
              style={{ width: '600px' }}
              value={initialVlue?.search}
              onChange={handleChange}
            />
          </div>

          <div className="dataTables_length">
            <button type="button" className="btn btn-primary me-2" onClick={() => getUserData(1)}>Search</button>
            <button type="button" className="btn btn-primary" onClick={() => reset(1)}>reset</button>
          </div>
        </div>
        <table className="table table-striped table-bordered ">
          <thead>
            <tr role="row" className="heading">
              <th>ID</th>
              <th>Name</th>
              <th>Email</th>
              <th>Role</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {data &&
              data.map((item, i) => {
                return (
                  <tr role="row" className="odd" key={i + 1}>
                    <td>
                      <span>{i + 1}</span>
                    </td>
                    <td>
                      <span>{item.firstname}</span>
                    </td>
                    <td>{item.email}</td>
                    <td>{item.role}</td>
                    <td>
                      <div className="dropdown">
                        <button
                          className="btn btn-primary dropdown-toggle"
                          type="button"
                          id="dropdownMenuButton1"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          Action
                        </button>
                        <ul className="dropdown-menu">
                          {/* <li>
                            <Link
                              className="dropdown-item"
                              to={`#`}
                              onClick={() => handleShow(true)}
                            >
                              Chart
                            </Link>
                          </li> */}

                          <li>
                            <Link
                              className="dropdown-item"
                              to={`edit/${item._id}`}
                            >
                              Edit
                            </Link>
                          </li>
                          <li>
                            <a className="dropdown-item" href="#" onClick={() => { handleDelete(item._id) }}>
                              Delete
                            </a>
                          </li>
                          <li>
                            <Link
                              className="dropdown-item"
                              to={`#`}
                              onClick={() => passModalOpen(item._id)}
                            >
                              Password Change
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
      <PasswordChange
        show={showPass}
        onHide={() => setShowPass(false)}
        passid={passid}
      />


      <Modal show={show} size="lg">
        <Modal.Header>
          <Modal.Title>Charts</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ChartsBody />
          <div style={{ display: "flex" }}>
            <input placeholder="Drop Your Message !" className="form-control" />
            <button type="button" style={{ padding: "0 40px" }} class="btn btn-success">Send</button>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={handleShow}>Close</Button>
        </Modal.Footer>
      </Modal>

    </>
  );
};

export default AdminUsersTable;
